<tr class="table-row-divided table-row-{{statusClass}} table-row-hover" (click)="collapse.toggle()">
  <td class="m-0 p-0" style="width: 30px;">
    <div class="status-icon"
      [title]="statusDescription">
      <em class="fa-solid"
            [ngClass]="{
					'fa-triangle-exclamation' : isFailureEvent,
					'fa-circle-exclamation' : isWarningEvent,
					'fa-circle-info' : isInfoEvent,
					'fa-ban' : isInhibitEvent,
					'fa-gear' : isDebugEvent }"
      ></em>
    </div>
  </td>
  <td>
    <div class="d-flex flex-column">
      <strong [innerHTML]="eventDetails.signalName"></strong>
      <small class="text-muted" [innerHTML]="eventDetails.signalLabel | translate"></small>
    </div>
  </td>
  <td>
    <span [innerHTML]="eventDetails.code"></span>
  </td>
  <td class="d-none d-md-table-cell">
    <span [innerHTML]="description"></span>
  </td>
  <td class="d-none d-md-table-cell">
    <span [innerHTML]="formatDate(eventDetails.timestamp)"></span>
  </td>
  <td class="td-expand text-center">
    <button class="btn-collapse"
      [ngClass]="isCollapsed ? 'collapsed' : 'expanded'">
      <span class="fa-solid fa-chevron-right"></span>
    </button>
  </td>
</tr>

<tr class="table-secondary table-row-{{statusClass}}" #collapse="ngbCollapse" [animation]="false"
  [(ngbCollapse)]="isCollapsed">
  <td colspan="5">
    <div class="container-fluid">
      <div class="row justify-content-around">

        <!-- Timestamp & Description for mobile -->
        <div class="col-12 d-block d-md-none">
          <dl class="datalist mb-0 py-2 py-md-3">
            <dt translate>Timestamp</dt>
            <dd [innerText]="eventDetails.timestamp | date:'yyyy-MM-dd HH:mm:ss.SSS Z'"></dd>
            <dt translate="">Description</dt>
            <dd [innerHTML]="eventDetails.description"></dd>
          </dl>
        </div>

        @for (column of metadataKeys|keyvalue; track column) {
          <div class="col-12 col-md-4 col-lg-3">
            <dl class="datalist mb-0 py-2 py-md-3">
              @for (key of column.value; track key) {
                <dt [innerHTML]="key"></dt>
                <dd [innerHTML]="eventDetails.metadata[key]"></dd>
              }
            </dl>
          </div>
        }
      </div>
    </div>
  </td>
</tr>
